export default {
    data() {
        return {
            valid: {
                child_id: false,
                first_transaction_store_id: false,
                registration_store_id: false,
                country_id: false,
                gender: false,
                minimum_age: false,
                maximum_age: false,
                county_id: false,
                marketing: false,
                sms: null,
                viber: null,
                push: null,
                mail: null,
                minimum_total_transactions: false,
                maximum_total_transactions: false,
                minimum_total_redemptions: false,
                maximum_total_redemptions: false,
                minimum_total_amount: false,
                maximum_total_amount: false,
                minimum_current_balance: false,
                maximum_current_balance: false,
                birth_date: false,
            },
            error: {
                child_id: "",
                first_transaction_store_id: "",
                registration_store_id: "",
                country_id: "",
                gender: "",
                minimum_age: "",
                maximum_age: "",
                county_id: "",
                marketing: "",
                sms: "",
                viber: "",
                push: "",
                mail: "",
                minimum_total_transactions: "",
                maximum_total_transactions: "",
                minimum_total_redemptions: "",
                maximum_total_redemptions: "",
                minimum_total_amount: "",
                maximum_total_amount: "",
                minimum_current_balance: "",
                maximum_current_balance: "",
                birth_date: "",
            },
            errorMessages: {
                storeRequired: {
                    el: "Απαιτείται κατάστημα",
                    en: "Store is required",
                    it: "Il negozio è necessario",
                },
                countryRequired: {
                    el: "Απαιτείται χώρα",
                    en: "Country is required",
                    it: "Il paese è richiesto",
                },
                genderRequired: {
                    el: "Απαιτείται φύλο",
                    en: "Gender is required",
                    it: "Il genere è richiesto",
                },
                ageRequired: {
                    el: "Απαιτείται ηλικία",
                    en: "Age is required",
                    it: "Età richiesta",
                },
                countyRequired: {
                    el: "Απαιτείται νομός",
                    en: "County is required",
                    it: "Provincia richiesta",
                },
                attributeRequired: {
                    el: "Απαιτείται χαρακτηριστικό",
                    en: "Attribute is required",
                    it: "Attributo richiesto",
                },
                ageInvalid: {
                    el: "Η ηλικία πρέπει να είναι αριθμός μεταξύ 0 και 120",
                    en: "Age must be a number between 0 and 120",
                    it: "L'età deve essere un numero tra 0 e 120",
                },
                ageRangeInvalid: {
                    el: "Η ελάχιστη ηλικία δεν μπορεί να είναι μεγαλύτερη από τη μέγιστη",
                    en: "Minimum age cannot be greater than maximum age",
                    it: "L'età minima non può essere maggiore dell'età massima",
                },
                amountInvalid: {
                    el: "Το ποσό πρέπει να είναι θετικός αριθμός",
                    en: "Amount must be a positive number",
                    it: "L'importo deve essere un numero positivo",
                },
                rangeInvalid: {
                    el: "Η ελάχιστη τιμή δεν μπορεί να είναι μεγαλύτερη από τη μέγιστη",
                    en: "Minimum value cannot be greater than maximum value",
                    it: "Il valore minimo non può essere maggiore del valore massimo",
                },
                birthDateFormat: {
                    el: "Η ημερομηνία πρέπει να είναι σε μορφή YYYY-MM-DD",
                    en: "Date must be in YYYY-MM-DD format",
                    it: "La data deve essere nel formato YYYY-MM-DD",
                },
                birthDateFuture: {
                    el: "Η ημερομηνία δεν μπορεί να είναι στο μέλλον",
                    en: "Date cannot be in the future",
                    it: "La data non può essere nel futuro",
                },
                birthDateOld: {
                    el: "Η ημερομηνία είναι υπερβολικά παλιά",
                    en: "Date is too far in the past",
                    it: "La data è troppo vecchia",
                },
            },
        };
    },

    methods: {
        validateChildId(filters, lang) {
            if (!filters.child_id) {
                this.error.child_id = this.errorMessages.storeRequired[lang];
                this.valid.child_id = false;
                return [this.error.child_id];
            }
            this.error.child_id = "";
            this.valid.child_id = true;
            return [];
        },
        validateFirstTransactionStoreId(filters, lang) {
            if (!filters.first_transaction_store_id) {
                this.error.first_transaction_store_id =
                    this.errorMessages.storeRequired[lang];
                this.valid.first_transaction_store_id = false;
                return [this.error.first_transaction_store_id];
            }
            this.error.first_transaction_store_id = "";
            this.valid.first_transaction_store_id = true;
            return [];
        },
        validateRegistrationStoreId(filters, lang) {
            if (!filters.registration_store_id) {
                this.error.registration_store_id =
                    this.errorMessages.storeRequired[lang];
                this.valid.registration_store_id = false;
                return [this.error.registration_store_id];
            }
            this.error.registration_store_id = "";
            this.valid.registration_store_id = true;
            return [];
        },
        validateCountryId(filters, lang) {
            if (!filters.country_id) {
                this.error.country_id =
                    this.errorMessages.countryRequired[lang];
                this.valid.country_id = false;
                return [this.error.country_id];
            }
            this.error.country_id = "";
            this.valid.country_id = true;
            return [];
        },
        validateGender(filters, lang) {
            if (!filters.gender) {
                this.error.gender = this.errorMessages.genderRequired[lang];
                this.valid.gender = false;
                return [this.error.gender];
            }
            this.error.gender = "";
            this.valid.gender = true;
            return [];
        },
        validateMinimumAge(filters, lang) {
            const min = filters.minimum_age;
            const max = filters.maximum_age;
            if (min === null || min === undefined || min === "") {
                this.error.minimum_age = "";
                this.valid.minimum_age = true;
                return [];
            }
            if (isNaN(min) || min < 0 || min > 120) {
                this.error.minimum_age = this.errorMessages.ageInvalid[lang];
                this.valid.minimum_age = false;
                return [this.error.minimum_age];
            }
            if (max && Number(min) > Number(max)) {
                this.error.minimum_age =
                    this.errorMessages.ageRangeInvalid[lang];
                this.valid.minimum_age = false;
                return [this.error.minimum_age];
            }
            this.error.minimum_age = "";
            this.valid.minimum_age = true;
            return [];
        },
        validateMaximumAge(filters, lang) {
            const max = filters.maximum_age;
            const min = filters.minimum_age;
            if (max === null || max === undefined || max === "") {
                this.error.maximum_age = "";
                this.valid.maximum_age = true;
                return [];
            }
            if (isNaN(max) || max < 0 || max > 120) {
                this.error.maximum_age = this.errorMessages.ageInvalid[lang];
                this.valid.maximum_age = false;
                return [this.error.maximum_age];
            }
            if (min && Number(max) < Number(min)) {
                this.error.maximum_age =
                    this.errorMessages.ageRangeInvalid[lang];
                this.valid.maximum_age = false;
                return [this.error.maximum_age];
            }
            this.error.maximum_age = "";
            this.valid.maximum_age = true;
            return [];
        },
        validateCountyId(filters, lang) {
            if (!filters.county_id) {
                this.error.county_id = this.errorMessages.countyRequired[lang];
                this.valid.county_id = false;
                return [this.error.county_id];
            }
            this.error.county_id = "";
            this.valid.county_id = true;
            return [];
        },
        validateMarketing(filters) {
            this.error.marketing = "";
            this.valid.marketing = filters.marketing !== null;
            return [];
        },
        validateMarketingField(field, filters) {
            this.error[field] = "";
            this.valid[field] = filters[field] !== null;
            return [];
        },
        validateMinTotalTransactions(filters, lang) {
            const min = filters.minimum_total_transactions;
            const max = filters.maximum_total_transactions;
            if (min === null || min === undefined || min === "") {
                this.error.minimum_total_transactions = "";
                this.valid.minimum_total_transactions = true;
                return [];
            }
            if (isNaN(min) || min < 0) {
                this.error.minimum_total_transactions =
                    this.errorMessages.amountInvalid[lang];
                this.valid.minimum_total_transactions = false;
                return [this.error.minimum_total_transactions];
            }
            if (max && Number(min) > Number(max)) {
                this.error.minimum_total_transactions =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.minimum_total_transactions = false;
                return [this.error.minimum_total_transactions];
            }
            this.error.minimum_total_transactions = "";
            this.valid.minimum_total_transactions = true;
            return [];
        },
        validateMaxTotalTransactions(filters, lang) {
            const max = filters.maximum_total_transactions;
            const min = filters.minimum_total_transactions;
            if (max === null || max === undefined || max === "") {
                this.error.maximum_total_transactions = "";
                this.valid.maximum_total_transactions = true;
                return [];
            }
            if (isNaN(max) || max < 0) {
                this.error.maximum_total_transactions =
                    this.errorMessages.amountInvalid[lang];
                this.valid.maximum_total_transactions = false;
                return [this.error.maximum_total_transactions];
            }
            if (min && Number(max) < Number(min)) {
                this.error.maximum_total_transactions =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.maximum_total_transactions = false;
                return [this.error.maximum_total_transactions];
            }
            this.error.maximum_total_transactions = "";
            this.valid.maximum_total_transactions = true;
            return [];
        },
        validateMinTotalRedemptions(filters, lang) {
            const min = filters.minimum_total_redemptions;
            const max = filters.maximum_total_redemptions;
            if (min === null || min === undefined || min === "") {
                this.error.minimum_total_redemptions = "";
                this.valid.minimum_total_redemptions = true;
                return [];
            }
            if (isNaN(min) || min < 0) {
                this.error.minimum_total_redemptions =
                    this.errorMessages.amountInvalid[lang];
                this.valid.minimum_total_redemptions = false;
                return [this.error.minimum_total_redemptions];
            }
            if (max && Number(min) > Number(max)) {
                this.error.minimum_total_redemptions =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.minimum_total_redemptions = false;
                return [this.error.minimum_total_redemptions];
            }
            this.error.minimum_total_redemptions = "";
            this.valid.minimum_total_redemptions = true;
            return [];
        },
        validateMaxTotalRedemptions(filters, lang) {
            const max = filters.maximum_total_redemptions;
            const min = filters.minimum_total_redemptions;
            if (max === null || max === undefined || max === "") {
                this.error.maximum_total_redemptions = "";
                this.valid.maximum_total_redemptions = true;
                return [];
            }
            if (isNaN(max) || max < 0) {
                this.error.maximum_total_redemptions =
                    this.errorMessages.amountInvalid[lang];
                this.valid.maximum_total_redemptions = false;
                return [this.error.maximum_total_redemptions];
            }
            if (min && Number(max) < Number(min)) {
                this.error.maximum_total_redemptions =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.maximum_total_redemptions = false;
                return [this.error.maximum_total_redemptions];
            }
            this.error.maximum_total_redemptions = "";
            this.valid.maximum_total_redemptions = true;
            return [];
        },
        validateMinTotalAmount(filters, lang) {
            const min = filters.minimum_total_amount;
            const max = filters.maximum_total_amount;
            if (min === null || min === undefined || min === "") {
                this.error.minimum_total_amount = "";
                this.valid.minimum_total_amount = true;
                return [];
            }
            if (isNaN(min) || min < 0) {
                this.error.minimum_total_amount =
                    this.errorMessages.amountInvalid[lang];
                this.valid.minimum_total_amount = false;
                return [this.error.minimum_total_amount];
            }
            if (max && Number(min) > Number(max)) {
                this.error.minimum_total_amount =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.minimum_total_amount = false;
                return [this.error.minimum_total_amount];
            }
            this.error.minimum_total_amount = "";
            this.valid.minimum_total_amount = true;
            return [];
        },
        validateMaxTotalAmount(filters, lang) {
            const max = filters.maximum_total_amount;
            const min = filters.minimum_total_amount;
            if (max === null || max === undefined || max === "") {
                this.error.maximum_total_amount = "";
                this.valid.maximum_total_amount = true;
                return [];
            }
            if (isNaN(max) || max < 0) {
                this.error.maximum_total_amount =
                    this.errorMessages.amountInvalid[lang];
                this.valid.maximum_total_amount = false;
                return [this.error.maximum_total_amount];
            }
            if (min && Number(max) < Number(min)) {
                this.error.maximum_total_amount =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.maximum_total_amount = false;
                return [this.error.maximum_total_amount];
            }
            this.error.maximum_total_amount = "";
            this.valid.maximum_total_amount = true;
            return [];
        },
        validateMinCurrentBalance(filters, lang) {
            const min = filters.minimum_current_balance;
            const max = filters.maximum_current_balance;
            if (min === null || min === undefined || min === "") {
                this.error.minimum_current_balance = "";
                this.valid.minimum_current_balance = true;
                return [];
            }
            if (isNaN(min) || min < 0) {
                this.error.minimum_current_balance =
                    this.errorMessages.amountInvalid[lang];
                this.valid.minimum_current_balance = false;
                return [this.error.minimum_current_balance];
            }
            if (max && Number(min) > Number(max)) {
                this.error.minimum_current_balance =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.minimum_current_balance = false;
                return [this.error.minimum_current_balance];
            }
            this.error.minimum_current_balance = "";
            this.valid.minimum_current_balance = true;
            return [];
        },
        validateMaxCurrentBalance(filters, lang) {
            const max = filters.maximum_current_balance;
            const min = filters.minimum_current_balance;
            if (max === null || max === undefined || max === "") {
                this.error.maximum_current_balance = "";
                this.valid.maximum_current_balance = true;
                return [];
            }
            if (isNaN(max) || max < 0) {
                this.error.maximum_current_balance =
                    this.errorMessages.amountInvalid[lang];
                this.valid.maximum_current_balance = false;
                return [this.error.maximum_current_balance];
            }
            if (min && Number(max) < Number(min)) {
                this.error.maximum_current_balance =
                    this.errorMessages.rangeInvalid[lang];
                this.valid.maximum_current_balance = false;
                return [this.error.maximum_current_balance];
            }
            this.error.maximum_current_balance = "";
            this.valid.maximum_current_balance = true;
            return [];
        },
        validateBirthDate(filters, lang) {
            const value = filters.birth_date;
            if (!value) {
                this.error.birth_date = "";
                this.valid.birth_date = true;
                return [];
            }
            // Acceptable formats: YYYY-MM-DD (adjust if you use another format)
            const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
            if (!dateRegex.test(value)) {
                this.error.birth_date =
                    "Η ημερομηνία πρέπει να είναι σε μορφή YYYY-MM-DD";
                this.valid.birth_date = false;
                return [this.error.birth_date];
            }
            const date = new Date(value);
            const now = new Date();
            if (date > now) {
                this.error.birth_date =
                    "Η ημερομηνία δεν μπορεί να είναι στο μέλλον";
                this.valid.birth_date = false;
                return [this.error.birth_date];
            }
            const minDate = new Date();
            minDate.setFullYear(minDate.getFullYear() - 120);
            if (date < minDate) {
                this.error.birth_date = "Η ημερομηνία είναι υπερβολικά παλιά";
                this.valid.birth_date = false;
                return [this.error.birth_date];
            }
            this.error.birth_date = "";
            this.valid.birth_date = true;
            return [];
        },

        validateAttributeName(filters, lang) {
            if (!filters.attribute_name) {
                this.error.attribute_name =
                    this.errorMessages.attributeRequired[lang];
                this.valid.attribute_name = false;
                return [this.error.attribute_name];
            }
            this.error.attribute_name = "";
            this.valid.attribute_name = true;
            return [];
        },
    },

    watch: {
        ["filtersData.child_id"]: {
            immediate: true,
            handler(val) {
                this.valid.child_id = !!val;
            },
        },
        ["filtersData.first_transaction_store_id"]: {
            immediate: true,
            handler(val) {
                this.valid.first_transaction_store_id = !!val;
            },
        },
        ["filtersData.registration_store_id"]: {
            immediate: true,
            handler(val) {
                this.valid.registration_store_id = !!val;
            },
        },
        ["filtersData.country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.country_id = !!val;
            },
        },
        ["filtersData.gender"]: {
            immediate: true,
            handler(val) {
                this.valid.gender = !!val;
            },
        },
        ["filtersData.minimum_age"]: {
            immediate: true,
            handler(val) {
                this.valid.minimum_age = !isNaN(val) && val >= 0 && val <= 120;
            },
        },
        ["filtersData.maximum_age"]: {
            immediate: true,
            handler(val) {
                this.valid.maximum_age = !isNaN(val) && val >= 0 && val <= 120;
            },
        },
        ["filtersData.county_id"]: {
            immediate: true,
            handler(val) {
                this.valid.county_id = !!val;
            },
        },
        ["filtersData.sms"]: {
            immediate: true,
            handler(val) {
                this.valid.sms = val !== null;
            },
        },
        ["filtersData.viber"]: {
            immediate: true,
            handler(val) {
                this.valid.viber = val !== null;
            },
        },
        ["filtersData.push"]: {
            immediate: true,
            handler(val) {
                this.valid.push = val !== null;
            },
        },
        ["filtersData.mail"]: {
            immediate: true,
            handler(val) {
                this.valid.mail = val !== null;
            },
        },
        ["filtersData.attribute_name"]: {
            immediate: true,
            handler(val) {
                this.valid.attribute_name = !!val;
            },
        },

        ["filtersData.minimum_total_transactions"]: {
            immediate: true,
            handler(val) {
                this.valid.minimum_total_transactions = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.maximum_total_transactions"]: {
            immediate: true,
            handler(val) {
                this.valid.maximum_total_transactions = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.minimum_total_redemptions"]: {
            immediate: true,
            handler(val) {
                this.valid.minimum_total_redemptions = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.maximum_total_redemptions"]: {
            immediate: true,
            handler(val) {
                this.valid.maximum_total_redemptions = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.minimum_total_amount"]: {
            immediate: true,
            handler(val) {
                this.valid.minimum_total_amount = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.maximum_total_amount"]: {
            immediate: true,
            handler(val) {
                this.valid.maximum_total_amount = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.minimum_current_balance"]: {
            immediate: true,
            handler(val) {
                this.valid.minimum_current_balance = !isNaN(val) && val >= 0;
            },
        },
        ["filtersData.maximum_current_balance"]: {
            immediate: true,
            handler(val) {
                this.valid.maximum_current_balance = !isNaN(val) && val >= 0;
            },
        },
    },
};
